import AdminLayout from "@/views/admin/AdminLayout.vue"
import Estimates from "@/views/admin/sales/EstimateList.vue"
import EstimateInfo from "@/views/admin/sales/EstimateInfo.vue"
import EstimateView from "@/views/admin/sales/EstimateView.vue"
import EstimateViewCustomer from "@/views/admin/sales/EstimateViewCustomer.vue"
import EstimateExport from "@/components/EstimateViewPage"

const routes = [
  {
    path: "/share/estimates/:id",
    name: "SharedEstimateView",
    component: EstimateViewCustomer,
    meta: {
      title: "EstimatesAndInvoices.__ShareEstimate",
      requireAuth: false,
      back2Auth: false,
      auth: 0
    }
  },
  {
    path: "/:lang/estimates/export/:id",
    name: "EstimateExport",
    component: EstimateExport,
    props: route => ({
      ...route.params
    }),
    meta: {
      title: "ActionOption.__ExportPDF",
      requireAuth: false,
      back2Auth: false,
      auth: 0
    }
  },
  {
    path: "/:lang/estimates",
    component: AdminLayout,
    children: [
      {
        path: "",
        name: "Estimates",
        meta: {
          title: "EstimatesAndInvoices.__Estimate",
          requireAuth: true,
          auth: 0
        },
        component: Estimates,
        props: route => ({
          ...route.params
        })
      },
      {
        path: "new",
        name: "EstimateNew",
        meta: {
          title: "EstimatesAndInvoices.__CreateEstimate",
          requireAuth: true,
          auth: 0
        },
        component: EstimateInfo
      },
      {
        path: "edit/:id",
        name: "EstimateEdit",
        meta: {
          title: "EstimatesAndInvoices.__EditEstimate",
          requireAuth: true,
          auth: 0
        },
        component: EstimateInfo
      },
      {
        path: "customer-view/:id",
        name: "EstimateCustomerView",
        meta: {
          title: "EstimatesAndInvoices.__PreviewAsCustomer",
          requireAuth: true,
          auth: 0
        },
        component: EstimateViewCustomer
      },
      {
        path: ":id",
        name: "EstimateView",
        meta: {
          title: "EstimatesAndInvoices.__Estimate",
          requireAuth: true,
          auth: 0
        },
        component: EstimateView
      }
    ]
  }
]

export default routes
